<template>
	<v-app class="user-v-app">
		<v-app-bar
			:absolute="$vuetify.breakpoint.lgAndUp"
			app
			color="#292931"
			dark
			class="my-appbar"
			:fixed="$vuetify.breakpoint.mdAndDown"
		>
			<v-app-bar-nav-icon
				aria-label="menu button"
				v-if="$vuetify.breakpoint.mdAndDown"
				@click.stop="drawer = !drawer"
			></v-app-bar-nav-icon>

			<v-toolbar-title>
				<router-link
					class="site-name"
					:to="{ name: 'UserMain' }"
					v-if="$vuetify.breakpoint.lgAndUp"
				>
					<span>CARRERAS KINESIA</span>
				</router-link>

				<router-link
					class="site-name"
					:to="{ name: 'UserMain' }"
					v-else-if="user.id"
				>
					<v-img
						height="32"
						width="32"
						class="kinesia-logo"
						src="/favicon.png"
					></v-img>
				</router-link>

				<router-link
					class="site-name"
					:to="{ name: 'UserMain' }"
					v-else-if="!user.id"
				>
					<v-img
						height="32"
						width="32"
						class="marginless-kinesia-logo"
						src="/favicon.png"
					></v-img>
				</router-link>
			</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-menu
				v-if="user.id && $vuetify.breakpoint.lgAndUp"
				offset-y
				rounded="lg"
			>
				<template #activator="{ attrs, on }">
					<v-btn icon v-bind="attrs" v-on="on" class="mx-1">
						<v-avatar size="40" class="avatar">
							<v-img
								:src="avatarSrc"
								alt="profile pic"
								referrerpolicy="no-referrer"
							>
							</v-img>
						</v-avatar>
					</v-btn>
				</template>
				<v-list>
					<v-list-item :to="{ name: 'UserProfile' }">
						<v-list-item-title> Mi perfil </v-list-item-title>
					</v-list-item>
					<v-list-item :to="{ name: 'MyRaces' }">
						<v-list-item-title> Mis carreras </v-list-item-title>
					</v-list-item>
					<v-list-item @click="logout">
						<v-list-item-title> Cerrar sesión </v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>

			<v-btn
				outlined
				color="accent"
				class="mx-2 my-2 rounded-lg"
				:to="{ name: 'UserLogin' }"
				v-if="!user.id"
				>Login</v-btn
			>
			<v-btn
				class="register-button my-2 rounded-lg"
				color="accent"
				elevation="0"
				v-if="!user.id"
				:to="{ name: 'UserRegister' }"
				>Registro</v-btn
			>

			<template v-slot:extension v-if="$vuetify.breakpoint.lgAndUp">
				<v-tabs grow color="accent">
					<v-tab :to="{ name: 'UserMain' }" exact>
						<span>
							<v-icon class="tab-icon">mdi-home</v-icon> Inicio
						</span>
					</v-tab>
					<v-tab :to="{ name: 'UserProfile' }" exact>
						<span>
							<v-icon class="tab-icon">mdi-account-circle</v-icon>
							Mi Perfil
						</span>
					</v-tab>
					<v-tab :to="{ name: 'MyRaces' }" exact>
						<span>
							<v-icon class="tab-icon">mdi-run</v-icon> Mis
							Carreras
						</span>
					</v-tab>
				</v-tabs>

				<v-progress-linear
					class="my-progess-loading"
					indeterminate
					color="accent"
					absolute
					bottom
					v-if="loading && $vuetify.breakpoint.mdAndDown"
				></v-progress-linear>
			</template>
		</v-app-bar>

		<v-navigation-drawer
			v-if="$vuetify.breakpoint.mdAndDown && user.id"
			app
			floating
			width="300"
			height="100%"
			v-model="drawer"
		>
			<div class="my-navigation-drawer-content">
				<div class="user-card">
					<v-avatar class="avatar" size="72">
						<v-img
							:src="avatarSrc"
							alt="profile picture"
							referrerpolicy="no-referrer"
						></v-img>
					</v-avatar>
					<p class="username">{{ user.username }}</p>
				</div>

				<div class="actions">
					<div class="small-cards-container">
						<small-card
							class="small-card"
							icon="mdi-home"
							color2="#bfaa7f"
							:to="{ name: 'UserMain' }"
						>
							Inicio
						</small-card>
						<small-card
							class="small-card"
							icon="mdi-account"
							color2="#bfaa7f"
							:to="{ name: 'UserProfile' }"
						>
							Mi Perfil
						</small-card>
						<small-card
							class="small-card"
							icon="mdi-run"
							color2="#bfaa7f"
							:to="{ name: 'MyRaces' }"
						>
							Mis Carreras
						</small-card>
						<!-- <small-card
							class="small-card"
							icon="mdi-poll"
							color2="#bfaa7f"
							:to="{ name: 'UserMain' }"
						>
							Mi ránking
						</small-card>-->
					</div>
				</div>

				<v-btn
					class="logout-button rounded-lg"
					text
					color="#b0b0b6"
					@click="logout"
					>Cerrar sesión</v-btn
				>
			</div>
		</v-navigation-drawer>

		<v-navigation-drawer
			v-else-if="$vuetify.breakpoint.mdAndDown"
			app
			width="300"
			v-model="drawer"
			height="100%"
		>
			<div class="my-navigation-drawer-content">
				<div class="user-card">
					<v-avatar class="avatar">
						<v-icon size="72" color="#b0b0b6">mdi-account</v-icon>
					</v-avatar>
					<p class="guest username">Invitado</p>

					<v-btn
						class="register-button rounded-lg"
						color="accent"
						elevation="0"
						:to="{ name: 'UserRegister' }"
						>Registro</v-btn
					>
					<v-btn
						class="login-button rounded-lg"
						outlined
						color="accent"
						:to="{ name: 'UserLogin' }"
						>Login</v-btn
					>
				</div>

				<div class="actions guest">
					<div class="small-cards-container">
						<small-card
							class="small-card"
							icon="mdi-home"
							color2="#bfaa7f"
							:to="{ name: 'UserMain' }"
							>Inicio</small-card
						>
						<small-card
							class="small-card"
							icon="mdi-account"
							color2="#bfaa7f"
							:to="{ name: 'UserProfile' }"
							>Mi Perfil</small-card
						>
						<small-card
							class="small-card"
							icon="mdi-run"
							color2="#bfaa7f"
							:to="{ name: 'MyRaces' }"
							>Mis Carreras</small-card
						>
						<!-- <small-card
							class="small-card"
							icon="mdi-poll"
							color2="#bfaa7f"
							:to="{ name: 'UserMain' }"
						>
							Mi ránking
						</small-card>-->
					</div>
				</div>
			</div>
		</v-navigation-drawer>
		<v-main class="main-content">
			<div v-if="showIosInstall"></div>
			<!-- Router view for the user root view -->
			<router-view
				@install-app="install"
				:deferredPrompt="deferredPrompt"
				@snackbar-event="showSnackbar"
				@loading="showLoading"
				@logout="logout"
				:iOSBanner="showIosInstall"
			></router-view>

			<!-- Snackbar to show error/success messages -->
			<v-snackbar
				class="snackbar-component"
				app
				v-model="snackbar"
				:timeout="timeout"
				:color="snackbarColor"
				:top="$vuetify.breakpoint.mdAndDown"
				rounded="lg"
			>
				<div v-html="snackbarText" class="snackbar-text"></div>

				<template v-slot:action="{ attrs }">
					<v-btn text v-bind="attrs" @click="snackbar = false"
						>Cerrar</v-btn
					>
				</template>
			</v-snackbar>
		</v-main>

		<v-footer dark padless app inset absolute class="my-footer">
			<v-card
				elevation="0"
				tile
				class="secondary white--text text-center"
				width="100%"
			>
				<v-card-text>
					<v-btn
						v-for="icon in footerIcons"
						:key="icon.icon"
						:href="icon.url"
						class="mx-4 white--text"
						icon
						:aria-label="icon.alt"
					>
						<v-icon size="24px">{{ icon.icon }}</v-icon>
					</v-btn>
				</v-card-text>

				<img
					class="strava-compatible-img"
					src="../assets/User/compatible_with_strava.svg"
					alt="compatible
				with strava"
				/>

				<v-card-text>
					En caso de cualquier problema, acceda al
					<a
						class="white--text"
						href="https://carreraskinesia.atlassian.net/servicedesk/"
					>
						<b>Centro de Soporte</b> </a
					>, contacte con nosotros llamando al <b>949 90 70 60</b> o
					mandando un correo a
					<b>
						<a
							class="white--text"
							href="mailto:info@carreraskinesia.com"
							>info@carreraskinesia.com</a
						>
					</b>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-text class="white--text footer-content">
					<div class="footer-row">
						<span class="my-1"
							>&copy;{{ new Date().getFullYear() }} KINESIA</span
						>

						<v-spacer></v-spacer>

						<v-btn
							text
							rounded
							dark
							:to="{ name: 'AvisoLegal' }"
							class="rounded-lg mx-2 my-1"
							>Aviso legal</v-btn
						>
						<v-btn
							text
							class="rounded-lg mx-2 my-1"
							dark
							:to="{ name: 'PoliticaPrivacidad' }"
							>Política de privacidad</v-btn
						>
					</div>
				</v-card-text>
			</v-card>
		</v-footer>
	</v-app>
</template>

<script>
import axios from "axios";
import SmallCard from "../components/user/SmallCard";
export default {
	name: "User",
	components: {
		SmallCard,
	},
	data: () => ({
		deferredPrompt: null,

		snackbarText: "",
		snackbar: false,
		timeout: 10000,
		snackbarColor: "error",
		loading: false,

		showIosInstall: false,

		drawer: null,

		footerIcons: [
			{
				icon: "mdi-facebook",
				alt: "facebook icon",
				url: "https://www.facebook.com/sportkinesia",
			},
			{
				icon: "mdi-twitter",
				alt: "twitter icon",
				url: "https://twitter.com/Sportkinesia",
			},
			{
				icon: "mdi-youtube",
				alt: "youtube icon",
				url:
					"https://www.youtube.com/channel/UCu8SkB0JsvdemQ-60gi1faw?view_as=subscriber",
			},
			{
				icon: "mdi-instagram",
				alt: "instagram icon",
				url: "https://www.instagram.com/sportkinesia/",
			},
		],
	}),
	computed: {
		token() {
			return this.$store.getters["user/getToken"];
		},
		user() {
			return this.$store.getters["user/getUser"];
		},
		avatarSrc() {
			if (this.user.id) {
				return this.user.avatar;
			}
			return "";
		},
	},
	methods: {
		//We open the snackbar and set color and text
		showSnackbar(e) {
			this.snackbarText = e.text;
			this.snackbarColor = e.color;
			this.snackbar = true;
		},
		async logout() {
			try {
				await axios.post("/user/logout");
			} catch (error) {
				//Not important to handle in prod
			} finally {
				this.$store.dispatch("user/logoutSuccess");
				this.$router.go();
			}
		},

		showLoading(loading) {
			if (!loading) {
				setTimeout(() => {
					this.loading = loading;
				}, 200);
			} else {
				this.loading = loading;
			}
		},
		async dismiss() {
			this.deferredPrompt = null;
		},
		async install() {
			this.deferredPrompt.prompt();
		},
	},
	async mounted() {
		try {
			await this.$store.dispatch("user/fetchUser");

			//In case there was a redirection to validate a user
			const verification = this.$route.query.verified;
			if (verification) {
				if (verification === "true") {
					this.snackbar = true;
					this.snackbarColor = "success";
					this.snackbarText =
						"Se ha validado el usuario correctamente, ahora puede iniciar sesión";
					this.$router.push({ name: "UserLogin" });
				} else if (verification === "false") {
					this.snackbar = true;
					this.snackbarColor = "error";
					this.snackbarText =
						"No se ha podido validar el usuario, por favor contacte con nosotros";
					this.$router.push({ name: "UserMain" });
				}
			}
		} catch (error) {
			if (error.response && error.response.status === 401) {
				this.$store.dispatch("user/logoutSuccess");
				//Do nothing as the user doesn't have to be logged in to be here
			} else {
				this.$emit("snackbar-event", {
					color: "error",
					text: "Ha ocurrido un error, vuelva a intentarlo más tarde",
				});
			}
		}

		if (this.user.id && (!this.user.dateOfBirth || !this.user.gender)) {
			this.$emit("snackbar-event", {
				color: "info",
				text: `Para finalizar el registro, termine de rellenar sus datos en <a style="color:#fff;" href="/app/profile?editing=true"><b>MI PERFIL</b></a>`,
			});
		}
	},
	created() {
		window.addEventListener("beforeinstallprompt", (e) => {
			e.preventDefault();
			// Stash the event so it can be triggered later.
			this.deferredPrompt = e;
		});
		window.addEventListener("appinstalled", () => {
			this.deferredPrompt = null;
		});

		// Detects if device is on iOS
		const isIos = () => {
			const userAgent = window.navigator.userAgent.toLowerCase();
			return /iphone|ipad|ipod/.test(userAgent);
		};
		// Detects if device is in standalone mode
		const isInStandaloneMode = () =>
			"standalone" in window.navigator && window.navigator.standalone;

		// Checks if should display install popup notification:
		if (isIos() && !isInStandaloneMode()) {
			this.showIosInstall = true;
		}

		this.$on("snackbar-event", (e) => {
			this.snackbarText = e.text;
			this.snackbarColor = e.color;
			this.snackbar = true;
		});
	},
};
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";
@import "../scss/_mixins.scss";

.my-appbar {
	.site-name {
		text-decoration: none;
		color: #fff;
	}

	.avatar {
		box-sizing: content-box;
		border: 2px solid var(--v-accent-base);
	}

	.my-progess-loading {
		transform: translateY(4px);
	}

	.kinesia-logo {
		position: absolute;
		transform: translate(-50%, -50%);

		@media (min-width: 250px) {
			left: 50%;
		}
	}

	.marginless-kinesia-logo {
		transform: translateX(-45%);

		@media (max-width: 330px) {
			display: none;
		}
	}
}

.tab-icon {
	transform: translateY(-1px);
}

.my-navigation-drawer-content {
	background-color: rgb(15, 15, 22);
	display: flex;
	flex-direction: column;
	min-height: 100%;
	align-items: center;

	.user-card {
		margin-top: 3em;
		justify-self: flex-start;
		display: flex;
		flex-direction: column;

		.register-button {
			margin-bottom: 1em;
		}

		.avatar {
			align-self: center;
			box-sizing: content-box;
			border: 3px solid var(--v-accent-base);
		}

		.username {
			text-align: center;
			color: #fff;
			font-size: 1.6em;
			font-weight: 300;
			font-variant: small-caps;
			margin-top: 0.3em;
		}

		.guest {
			color: #b0b0b6;
		}
	}

	.actions {
		width: 100%;
		border-radius: 8px;
		margin: 2em 0;

		@include desktop() {
			position: relative;
			top: -2em;
			margin: auto 0;

			&.guest {
				top: -4em;
			}
		}

		.small-card {
			margin: 0;
			width: 100%;

			@include desktop() {
				margin: 1em 0;
			}
		}
	}

	.logout-button {
		width: fit-content;
		padding: 1em;

		margin: auto 0 5em 0;

		@include desktop() {
			margin: 2em 0;
		}
	}
}

.main-content {
	background-color: #f0f0f3;
}

.snackbar-component {
	padding: 1em !important;

	.snackbar-text {
		font-size: 1.1em;
	}
}

.my-footer {
	.footer-content {
		display: flex;
		flex-wrap: wrap;
		padding: 1em 2em;

		a {
			color: #fff;

			&.email {
				margin: 0;
			}
		}

		.footer-row {
			display: flex;
			flex-wrap: wrap;
			flex-direction: column;
			width: 100%;
			align-content: center;

			@include desktop() {
				flex-direction: row;
			}
		}
	}
}

.strava-compatible-img {
	height: 3em;
}
</style>